import { find, propEq } from 'ramda';

/**
 * @typedef {Function} ScreenLookupFunction
 * @param {Array} screens
 * @returns {object} The selected screen.
 */

/**
 * Convenience function to create a {@link ScreenLookupFunction} for a given prop.
 *
 * @param {string} prop - The prop to match on.
 * @returns {ScreenLookupFunction} Function to do the lookup.
 */
export const makeSelector = (prop) => (value) => find(propEq(prop, value)); // exported for testing

/**
 *
 * Select an offer screen by its type.
 *
 * @param {string} name - The screen.type to search for.
 * @returns {ScreenLookupFunction} Function to do the lookup.
 */
export const selectScreenByType = makeSelector('type');
